import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { fetchProjectsData } from './Data';
import './testimonials.css';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [error, setError] = useState(null);
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchProjectsData();
        setTestimonials(data);
        setError(null);
      } catch (err) {
        console.error('Fetch error:', err);
        setError('Failed to load testimonials.');
      }
    };

    fetchData();
  }, []);

  // Variants for animations
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: 'spring',
        damping: 15,
        stiffness: 120,
      },
    },
  };

  return (
    <motion.section
      className="testimonials section"
      id="testimonials"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.h2 className="section__title" variants={cardVariants}>
        What Our Clients Say
      </motion.h2>

      <motion.span className="section__subtitle" variants={cardVariants}>
        Feedback from our clients
      </motion.span>

      {error && (
        <motion.div
          className="error-message"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          {error}
        </motion.div>
      )}

      <motion.div
        className="slider"
        style={{
          '--width': '250px',    // Updated from 350px
          '--height': '300px',   // Updated from 400px
          '--quantity': duplicatedTestimonials.length,
        }}
        variants={containerVariants}
      >
        <motion.div className="list">
          {testimonials.length > 0 ? (
            duplicatedTestimonials.map((testimonial, index) => (
              <motion.div
                className="item"
                key={`${testimonial.id}-${index}`}
                style={{ '--position': index + 1 }}
                variants={cardVariants}
              >
                <div className="testimonial__card">
                  <img
                    src={testimonial.image}
                    alt={testimonial.title}
                    className="testimonial__img"
                    loading="lazy"
                  />
                  <h3 className="testimonial__name">{testimonial.title}</h3>
                  <p className="testimonial__description">
                    {testimonial.description}
                  </p>
                </div>
              </motion.div>
            ))
          ) : !error && (
            <motion.div
              className="loading"
              initial={{ opacity: 0 }}
              animate={{ 
                opacity: [0.4, 1, 0.4],
                transition: { repeat: Infinity, duration: 1.5 }
              }}
            >
              Loading testimonials...
            </motion.div>
          )}
        </motion.div>
      </motion.div>
    </motion.section>
  );
};

export default Testimonials;
